"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useModalAttributes", {
    enumerable: true,
    get: ()=>useModalAttributes
});
const _reactUtilities = require("@fluentui/react-utilities");
const _useTabsterAttributes = require("./useTabsterAttributes");
const _tabster = require("tabster");
const _useTabster = require("./useTabster");
const useModalAttributes = (options = {})=>{
    const { trapFocus , alwaysFocusable , legacyTrapFocus  } = options;
    const tabster = (0, _useTabster.useTabster)();
    // Initializes the modalizer and deloser APIs
    if (tabster) {
        (0, _tabster.getModalizer)(tabster);
        (0, _tabster.getDeloser)(tabster);
    }
    const id = (0, _reactUtilities.useId)('modal-', options.id);
    const modalAttributes = (0, _useTabsterAttributes.useTabsterAttributes)({
        deloser: {},
        modalizer: {
            id,
            isOthersAccessible: !trapFocus,
            isAlwaysAccessible: alwaysFocusable,
            isTrapped: legacyTrapFocus && trapFocus
        }
    });
    const triggerAttributes = (0, _useTabsterAttributes.useTabsterAttributes)({
        deloser: {}
    });
    return {
        modalAttributes,
        triggerAttributes
    };
}; //# sourceMappingURL=useModalAttributes.js.map

//# sourceMappingURL=useModalAttributes.js.map